require('./lbTripOptionsModal.scss');

const $inject = [];

const lbTripOptionsModal = {
  controller: 'lbTripOptionsModalCtrl as vm',
  template: require('./lbTripOptionsModal.html'),
  bindings: {},
};

lbTripOptionsModal.$inject = $inject;

export default lbTripOptionsModal;



// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsModal.js